export default "__VITE_ASSET__5b0ca867__"